import * as React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { DocumentCreationWizard } from '../components/DocumentCreationWizard';
import { DocumentFormData } from '../types';
import { toast } from 'sonner';
import { DocumentsService } from '../services/documents-service';

export function AddDocumentPage() {
  const [isLoading, setIsLoading] = React.useState(false);
  const navigate = useNavigate();

  const handleFileUpload = async (file: File) => {
    try {
      const result = await DocumentsService.uploadFile(file);
      
      if (result.success) {
        return result.file;
      } else {
        throw new Error('Upload failed');
      }
    } catch (error) {
      console.error('File upload error:', error);
      throw error;
    }
  };

  const handleSubmit = async (data: DocumentFormData, fileInfo: any) => {
    try {
      setIsLoading(true);

      // Combine form data with file information for the API
      const documentData = {
        ...data,
        media: {
          storage_path: fileInfo.storage_path,
          file_type: fileInfo.file_type,
          file_size: fileInfo.file_size,
          color_mode: 'color' as const
        },
        preservation: {
          ...data.preservation,
          date_archived: new Date().toISOString()
        },
        // OCR data from the file upload
        ocr_text: fileInfo.ocr_text || '',
        ocr_quality: fileInfo.ocr_quality || 'basic'
      };

      const result = await DocumentsService.createDocument(documentData);
      console.log('Document created:', result);
      toast.success(`Document created successfully with ID: ${result.id}`);
      
      // Navigate to the documents list
      navigate({ to: '/documents' });
    } catch (error) {
      console.error('Error creating document:', error);
      toast.error('Failed to create document');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    navigate({ to: '/documents' });
  };

  return (
    <DocumentCreationWizard
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      onFileUpload={handleFileUpload}
      isLoading={isLoading}
    />
  );
}
